<template>

<!--
	A gentle opt-in on the result screen: shown to a signed-in player who hasn't
	set a daily reminder yet. It points them to Settings to choose a time, rather
	than guessing one for them. Dismissing hides it for good on this device, so it
	never nags.
-->

<div v-if="state === 'prompt'" class="rem">
	<button type="button" class="rem-x" aria-label="Dismiss" v-on:click="dismiss">&times;</button>
	<div class="rem-text">
		<div class="rem-title">Don’t miss tomorrow’s?</div>
		<div class="rem-sub">Set a daily reminder to play, before the day rolls over.</div>
	</div>
	<router-link to="/settings" class="rem-btn">Set a reminder</router-link>
</div>

</template>

<script>

import { load } from '../../service/reminder'

var DISMISS_KEY = 'boxart.reminderPrompt.dismissed'

export default {

	name: 'EndReminder',

	data: function() {

		return {
			// 'hidden' | 'prompt'
			state: 'hidden',
			// guards against running the load check more than once
			checked: false
		}

	},

	computed: {

		signedIn: function() {

			return this.$store.getters['account/signedIn']

		}

	},

	created: function() {

		this.maybePrompt()

	},

	watch: {

		// the session recognises asynchronously on boot; if it resolves after we
		// mount, run the check then (so a reloaded result still gets the prompt)
		signedIn: function(now) {

			if (now) this.maybePrompt()

		}

	},

	methods: {

		// decide whether to show the opt-in: signed in, not dismissed, no reminder
		maybePrompt: function() {

			var self = this

			if (!this.signedIn || this.state !== 'hidden' || this.checked) return

			// respect a previous dismissal
			try {

				if (localStorage.getItem(DISMISS_KEY) === '1') return

			} catch (e) { /* storage off — just proceed */ }

			this.checked = true

			load().then(function(json) {

				if (json && !json.error && !json.enabled) self.state = 'prompt'

			})

		},

		dismiss: function() {

			this.state = 'hidden'

			try {

				localStorage.setItem(DISMISS_KEY, '1')

			} catch (e) { /* storage off — it'll just prompt again next time */ }

		}

	}

}

</script>

<style scoped>

.rem {
	position: relative;
	display: flex;
	align-items: center;
	gap: 12px;
	/* extra right padding reserves a gutter for the dismiss X so it never sits
	   over the Set-a-reminder button */
	padding: 14px 30px 14px 16px;
	border: 1px solid var(--hairline);
	border-radius: var(--radius);
	background: #fbf8f1;
}

.rem-x {
	position: absolute;
	top: 50%;
	right: 6px;
	transform: translateY(-50%);
	z-index: 2;
	width: 22px;
	height: 22px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0;
	background: none;
	border: none;
	font-size: 17px;
	line-height: 1;
	color: var(--muted-2);
	cursor: pointer;
}

.rem-text {
	flex: 1;
	min-width: 0;
}

.rem-title {
	font-family: var(--font-body);
	font-size: 14px;
	font-weight: 600;
	color: var(--ink);
}

.rem-sub {
	font-family: var(--font-body);
	font-size: 12.5px;
	line-height: 1.4;
	color: var(--muted-2);
	margin-top: 2px;
}

.rem-btn {
	flex: none;
	display: inline-flex;
	align-items: center;
	height: 36px;
	padding: 0 16px;
	border-radius: 8px;
	background: var(--ink);
	color: var(--paper);
	font-family: var(--font-body);
	font-size: 13px;
	font-weight: 600;
	text-decoration: none;
	white-space: nowrap;
}

.rem-btn:hover {
	background: var(--accent);
}

</style>
